<template lang="">
  <div>
    <div>
      <Header
        title="Lista de envios"
        subtitle="Agendamentos de SMS"
      ></Header>
      <template>
        <v-tabs
          v-model="tab"
          color='black'
          class="d-flex justify-start "
        >
          <v-tab href="#list" name="list" class="">
            <img width="20" src="../../../../static/images/calendar.svg"/>
            <span class="pl-3 ff">Lista</span>
          </v-tab>
          <v-tab href="#users" name="users" class="">
            <img width="20" src="../../../../static/images/folder.svg"/>
            <span class="pl-3 ff">Gestão de usuários</span>
          </v-tab>
        </v-tabs>
      </template>
      <div v-if="tab === 'list'">
       <List/>
      </div>
      <div v-if="tab === 'users'">
        <ListManagement />
      </div>
    </div>
  </div>
</template>
<script>
// Components
import Header from '@/components/Header.vue'
import Logs from '@/components/Contents/ScheduleWeb/Logs'
import List from '@/components/Contents/ScheduleWeb/List'
import ListManagement from '@/components/Contents/ScheduleWeb/ListManagement'

import { mapMutations } from "vuex";

export default {
  components: {
    Header,
    Logs,
    List,
    ListManagement
  },
  methods: {
    ...mapMutations("PushWebLogs", {
      setRequestUri: "SET_REQUEST_URI",
    }),
    changeEndpoint() {
       this.setRequestUri('/api/getMessgit reset --hard ages')
    }
  },
  async created() {
    await this.changeEndpoint();
  },

  data () {
    return {
      tab: 'list',
      drawer: true
    }
  }
}
</script>
<style lang="" scoped>
.v-tabs{
  margin-top:-2px
}
    .v-tabs-slider{
      color: pink;
      height:50px
    }
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/ShippingList.vue